import React from 'react'
// eslint-disable-next-line no-unused-vars
import { TKelmanCarousel } from './KelmanCarousel-types'

const KelmanCarousel: React.FC<TKelmanCarousel> = ({
  images,
  index,
  children
}) => {
  return images.length > 0 ? (
    <React.Fragment>
      <img
        style={{ width: '100%', position: 'absolute' }}
        src={images[index]}
        alt={index.toString()}
      />
    </React.Fragment>
  ) : (
    <div>{children}</div>
  )
}

export default KelmanCarousel
